import { createContext, useContext } from 'react';

const PrintContext = /*#__PURE__*/createContext(false);
function useIsPrintableContent() {
  return useContext(PrintContext);
}

export { PrintContext, useIsPrintableContent };
//# sourceMappingURL=context.print.js.map
